import React from 'react';
import styled from 'styled-components';

const QnAContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  background-color: #ffffff;
  min-height: 100vh;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 3rem;
  color: #1a1a1a;
  text-align: center;
  font-weight: 700;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 4px;
    background: linear-gradient(90deg, #4A90E2, #67B26F);
    border-radius: 2px;
  }
`;

const QnASection = styled.section`
  margin-bottom: 2.5rem;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
  transition: transform 0.2s ease-in-out;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  }
`;

const Question = styled.h2`
  font-size: 1.3rem;
  color: #2c3e50;
  margin-bottom: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  
  &:before {
    content: 'Q';
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, #4A90E2, #67B26F);
    color: white;
    border-radius: 50%;
    margin-right: 12px;
    font-size: 1rem;
    font-weight: bold;
  }
`;

const Answer = styled.div`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #4a5568;
  margin-left: 40px;
  position: relative;
  
  &:before {
    content: 'A';
    position: absolute;
    left: -40px;
    top: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: #f7fafc;
    color: #4A90E2;
    border: 2px solid #4A90E2;
    border-radius: 50%;
    font-size: 1rem;
    font-weight: bold;
  }
`;

const Highlight = styled.span`
  color: #e53e3e;
  font-weight: 600;
`;

const QnA: React.FC = () => {
  return (
    <QnAContainer>
      <Title>자주 묻는 질문</Title>
      
      <QnASection>
        <Question>앱을 처음 사용하는데 어떻게 시작하나요?</Question>
        <Answer>
          앱을 시작하기 위해서는 먼저 로그인을 해주세요.<br/>
          로그인 후 홈에서 학습을 시작할 수 있습니다.<br/>
          <Highlight>** 처음 로그인 이후는 자동 로그인됩니다. **</Highlight>
        </Answer>
      </QnASection>

      <QnASection>
        <Question>로그아웃 하고 싶어요</Question>
        <Answer>
          로그아웃을 하기 위해서는 하단 바의 맨 오른쪽 버튼을 클릭하여 프로필 화면으로 이동합니다.<br/>
          프로필 화면에서 로그아웃 버튼을 클릭하면 로그아웃이 완료됩니다.
        </Answer>
      </QnASection>

      <QnASection>
        <Question>제 랭킹은 왜 이렇게 낮아요</Question>
        <Answer>
          랭킹의 경우 매월 누적 점수를 통해 계산됩니다.<br/>
          점수를 올리기 위해서는 이미 했던 과제를 반복해서 진행 하시면 됩니다.<br/>
          <Highlight>** 복습은 점수 올리기에 큰 도움이 됩니다. **</Highlight>
        </Answer>
      </QnASection>

      <QnASection>
        <Question>과제 진행도가 실시간으로 반영이 안되요</Question>
        <Answer>
            인터넷 상태가 좋지 않을 경우 반영이 늦어질 수 있습니다.<br/>
            조금만 기다려 보시면 반영 됩니다.<br/>
        </Answer>
      </QnASection>

      <QnASection>
        <Question>앱의 기능이 작동이 안돼요</Question>
        <Answer>
          앱 기능이 작동하지 않는다면 앱 업데이트를 확인해 보세요. 업데이트가 되지 않는다면 앱 삭제 후 다시 설치해 보세요.<br/>
          앱 삭제 후 다시 설치해도 작동하지 않는다면 기기 성능을 확인해 보세요 기기 성능이 너무 낮으면 앱 작동이 안될 수 있습니다.<br/>
          권장 사양: 아이폰 IOS 13.0 이상, 안드로이드 9.0 이상<br/>
          <Highlight>** 일부 보급형 스마트폰에서는 코덱 문제로 영상 작동이 안될 수 있습니다. **</Highlight>
        </Answer>
      </QnASection>

      <QnASection>
        <Question>앱 삭제 후 다시 설치하면 데이터가 사라져요</Question>
        <Answer>
          앱 삭제 후 다시 설치하면 일부 기능의 데이터가 사라질 수 있습니다<br/>
          <Highlight>** 사라질 수 있는 데이터: 공지 사항, 로그인 정보, 앱 권한 정보 **</Highlight>
        </Answer>
      </QnASection>
    </QnAContainer>
  );
};

export default QnA; 